<script lang="ts">
  import { page } from '$app/stores';

  import { LogoDO } from '@shared/libs/lotties';
  import { BlaizeLabel } from '@shared/ui/blaize-label';
  import { Container } from '@shared/ui/container';
  import { cn } from '@shared/utils';

  import { InstitutionsSubscribeForm } from '@features/institutions-subscribe';

  import Socials from './socials.svelte';

  const fullLogoIconUID = Symbol();
  const fullLogoTextUID = Symbol();
  const currentYear = new Date().getFullYear();

  $: name = $page.data.configurations.name;
  $: isMainPage = $page.route.id === '/';
  $: href = isMainPage ? undefined : '/';

  $: displayName = $page.data.isUFDA ? 'Ukrainian Fund of Digitized Art' : $page.data.configurations.name;

  $: copyrightText = `© ${displayName}™ ${currentYear}`;
</script>

<footer class="bg-alt-dark text-default-50">
  <Container containerClass="py-6 md:py-8 lg:py-12">
    <div class="4xl:gap-12 mb-10 flex flex-col gap-12 md:mb-12 md:grid md:grid-cols-12 md:gap-x-8 xl:grid-cols-12">
      <div class="col-span-12 flex flex-col gap-10 md:flex-row md:gap-6 xl:col-span-7">
        <Socials />
      </div>

      <div class="md:col-span-7 xl:col-start-9 xl:col-end-13">
        <p class="mb-4 text-xl">
          Stay updated with <span class="capitalize">{name}</span>’s news and updates!
        </p>

        <InstitutionsSubscribeForm />
      </div>
    </div>

    <div
      class="text-dark-800 flex flex-col flex-wrap gap-10 text-base leading-[22px] md:flex-row md:items-center md:gap-6"
    >
      <div class="h-min w-full shrink-0 md:w-max lg:order-3 lg:ml-auto lg:w-max">
        <BlaizeLabel classes="w-full justify-center" />
      </div>

      <svelte:element
        this="{isMainPage ? 'div' : 'a'}"
        {href}
        title="{copyrightText}"
        class="{cn('text-dark-700 capitalize md:order-3 lg:order-2', {
          'hover:text-dark-900 transition-colors': !isMainPage,
        })}"
      >
        {copyrightText}
      </svelte:element>

      <div
        class="border-dark-400 text-dark-700 custom-gradient flex w-max items-center gap-3 rounded-full border px-4 py-3 md:order-2 md:px-5 lg:order-1"
      >
        <p>© Powered by</p>

        <a href="https://digitaloriginal.app" target="_blank">
          <LogoDO width="{94}" iconUID="{fullLogoIconUID}" textUID="{fullLogoTextUID}" />
        </a>
      </div>
    </div>
  </Container>
</footer>

<style lang="scss">
  .custom-gradient {
    background: linear-gradient(180deg, rgba(27, 27, 27, 0) 0%, rgba(153, 153, 153, 0.08) 100%);

    @media (min-width: 768px) {
      background: none;
    }
  }
</style>
